'use client';

export default function FirmSection() {
  return (
    <section id="our-firm" className="firm-section section-space">
      <div className="site-container firm-grid">
        <div className="firm-image-wrap">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_135f8ab04-1787164842439.png"
            alt="Harrington & Associates LLP office interior in New York City" />
          
          <div className="established-badge">
            <strong>2003</strong>
            <span>Established</span>
          </div>
        </div>
        <div className="firm-copy">
          <p className="eyebrow">About the firm</p>
          <h2>A Commitment to <em>Legal Excellence</em></h2>
          <p>
            Founded by Elena Vasquez in 2003, Harrington & Associates LLP has grown from a boutique litigation practice into one of New York City&apos;s most trusted legal advisors for individuals, families, and businesses. We combine rigorous preparation with creative strategy.
          </p>
          <p>
            When you retain Harrington & Associates LLP, you gain a team of dedicated advocates who treat your matter with the precision and care it deserves — from initial consultation through final resolution.
          </p>
          <ul>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
                <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
                <path d="M7 21h10" />
                <path d="M12 3v18" />
                <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
              </svg>
              Two decades of courtroom and negotiation experience
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                <path d="M12 18V6" />
              </svg>
              Partner-led strategy with transparent, honest communication
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                <path d="M10 6h4" />
                <path d="M10 10h4" />
                <path d="M10 14h4" />
                <path d="M10 18h4" />
              </svg>
              Tailored counsel for complex personal and commercial matters
            </li>
          </ul>
          <a href="#attorneys" className="text-link">
            Meet our team
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>);

}